import React, { useRef, useEffect, useState } from "react";

function AmbientGlow() {
  const pos = useRef({ x: -1000, y: -1000 });
  const rendered = useRef({ x: -1000, y: -1000 });
  const elRef = useRef(null);
  const [enabled, setEnabled] = useState(false);

  useEffect(() => {
    if (!window.matchMedia("(pointer: fine)").matches) return;
    setEnabled(true);

    const onMove = (e) => {
      pos.current = { x: e.clientX, y: e.clientY };
    };
    window.addEventListener("mousemove", onMove, { passive: true });

    let raf;
    const lerp = () => {
      rendered.current.x += (pos.current.x - rendered.current.x) * 0.06;
      rendered.current.y += (pos.current.y - rendered.current.y) * 0.06;
      if (elRef.current) {
        elRef.current.style.background = `radial-gradient(600px circle at ${rendered.current.x}px ${rendered.current.y}px, rgba(var(--color-surface) / 0.04), transparent 60%)`;
      }
      raf = requestAnimationFrame(lerp);
    };
    lerp();

    return () => {
      window.removeEventListener("mousemove", onMove);
      cancelAnimationFrame(raf);
    };
  }, []);

  if (!enabled) return null;

  return (
    <div
      ref={elRef}
      className="fixed inset-0 z-[2] pointer-events-none"
      style={{ willChange: "background" }}
    />
  );
}

export default React.memo(AmbientGlow);
